module.exports = __webpack_public_path__ + "img/icon_map_63_on_011.bf5379c4.png";